import { HttpMethod } from "../../components/Common/useFetch";
import { RequestOptions } from "../../components/Common/useRequest";
import useUserRequest from "../../components/Common/useUserRequest";
import { useSelectedBusiness } from "../../components/UserAccess/useSelectedBusiness";

interface BlendItemAmount {
  blendItemId: string;
  amount: number;
}

interface CreateOrderTransactionDto {
  orderId: string;
  siteId: string;
  transactionNumber: string;
  blendItemAmounts: BlendItemAmount[];
}

const useAddOrderTransaction = (options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();

  return useUserRequest<CreateOrderTransactionDto>({
    path: `/api/dev/createOrderTransaction/${business.id}`,
    method: HttpMethod.POST
  }, options);
}

export default useAddOrderTransaction;
